<mat-tab-group animationDuration="300ms" disableRipple="true" class="clickatell-tabs">
  <mat-tab>
    <ng-template mat-tab-label>Details</ng-template>
    @if (submission) {
      <div>
        <div class="approval-details">
          <div class="flow-title">
            {{ submission.flowPath || 'MISSING - Please re-submit to fix' }}
          </div>
          <!-- !! the default text should be removed after all current submissions are cleared -->
          @if (
            !submission.submissionType || submission.submissionType === 'PROMOTE') {
            @if (submission.state === 'PENDING') {
              <div class="flow-status">
                Status: Ready for Approval
              </div>
            }
            @if (submission.state === 'APPROVED') {
              <div class="flow-status">
                Status: Ready for Production
              </div>
            }
            @if (submission.state === 'DECLINED') {
              <div class="flow-status">Status: Declined</div>
            }
            @if (submission.state === 'DEPLOYED') {
              <div class="flow-status">
                Status: Deployed to Production
              </div>
            }
            @if (approvalsSelected === 'MY_APPROVALS') {
              <div class="flow-approval-buttons">
                <div class="slide-button">
                  <div class="ask-button">
                    <button class="btnPrimary flow-approval-button" (click)="showApprove()">
                      Approve
                    </button>
                    <button class="btnPrimary flow-approval-button" (click)="showDecline()">
                      Decline
                    </button>
                  </div>
                  <div class="confirm-div confirm-approve flow-approval-button-deploy">
                    <button class="btnPrimary confirm-button" (click)="actionSubmission('APPROVE')">
                      Yes
                    </button>
                    <div class="confirm-prompt">Confirm?</div>
                    <button class="btnPrimary decline-button" (click)="hideConfirm_Approve_Decline()">
                      No
                    </button>
                  </div>
                  <div class="confirm-div confirm-decline flow-approval-button-deploy">
                    <button class="btnPrimary confirm-button" (click)="actionSubmission('DECLINE')">
                      Yes
                    </button>
                    <div class="confirm-prompt">Confirm?</div>
                    <button class="btnPrimary decline-button" (click)="hideConfirm_Approve_Decline()">
                      No
                    </button>
                  </div>
                </div>
              </div>
            }
          } @else {
            <div class="flow-status">Status: Delete From Production</div>
            @if (approvalsSelected === 'MY_APPROVALS') {
              <div class="flow-approval-buttons">
                <div class="slide-button">
                  <div class="ask-button">
                    <button class="btnPrimary flow-approval-button" (click)="showApprove()">
                      Approve
                    </button>
                    <button class="btnPrimary flow-approval-button" (click)="showDecline()">
                      Decline
                    </button>
                  </div>
                  <div class="confirm-div confirm-approve flow-approval-button-deploy">
                    <button class="btnPrimary confirm-button" (click)="actionSubmission('APPROVE')">
                      Yes
                    </button>
                    <div class="confirm-prompt">Confirm?</div>
                    <button class="btnPrimary decline-button" (click)="hideConfirm_Approve_Decline()">
                      No
                    </button>
                  </div>
                  <div class="confirm-div confirm-decline flow-approval-button-deploy">
                    <button class="btnPrimary confirm-button" (click)="actionSubmission('DECLINE')">
                      Yes
                    </button>
                    <div class="confirm-prompt">Confirm?</div>
                    <button class="btnPrimary decline-button" (click)="hideConfirm_Approve_Decline()">
                      No
                    </button>
                  </div>
                </div>
              </div>
            }
          }
          @if (approvalsSelected === 'APPROVED' && rolesService.canDeploy()) {
            <div
              class="flow-approval-buttons"
              >
              <div class="slide-button">
                @if (!submission.submissionType || submission.submissionType === 'PROMOTE') {
                  <button
                    class="btnPrimary flow-approval-button-deploy ask-button"
                    (click)="showConfirm('deploy')"
                    >
                    Deploy to Production
                  </button>
                }
                @if (submission.submissionType && submission.submissionType === 'DELETE') {
                  <button
                    class="btnPrimary flow-approval-delete ask-button"
                    (click)="showConfirm('delete')"
                    >
                    Delete from Production
                  </button>
                }
                <div class="confirm-div flow-approval-button-deploy">
                  <button class="btnPrimary confirm-button" (click)="deployToProduction()">Yes</button>
                  <div class="confirm-prompt">Confirm?</div>
                  <button class="btnPrimary decline-button" (click)="hideConfirm()">No</button>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="approval-summary">
          <span class="approval-summary-bold">Client: {{ getClient() }}</span>
          <br />
          <span class="approval-summary-bold">Author: {{ submission.submitter }}</span>
          <br />
          Last Modified: {{ submission.cdcUpdateTimestamp | date: 'yyyy/MM/dd HH:mm:ss' }}
          <br />
          <br />
          <span class="approval-summary-bold">Summary:</span><br />
          {{ submission.summary }}
          <br />
          <br />
          @if (submissionApproval | async; as approval) {
            <div>
              <span class="approval-summary-bold"
                >Approved: {{ approval.status.TOTAL.approvedCount }}/{{
                approval.status.TOTAL.required
                }}</span
                >
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="approval-noSelection">Please select an approval on the left</div>
      }
    </mat-tab>
    @if (submission) {
      <mat-tab>
        <ng-template mat-tab-label>Change Log</ng-template>
        @if (changeLog | async; as changeLogs) {
          <div>
            @for (log of changeLogs; track log) {
              <div class="approval-summary approval-summary-border-bottom">
                <span class="approval-summary-bold">Author: {{ log.author }}</span
                  ><br />
                  Date modified: {{ log.date | date: 'yyyy/MM/dd HH:mm:ss' }}<br />
                  <br />
                  <span class="approval-summary-bold">Summary:</span> <br />
                  {{ log.message }}
                </div>
              }
            </div>
          } @else {
            <loading-icon></loading-icon>
          }
        </mat-tab>
      }
      @if (submission) {
        <mat-tab>
          <ng-template mat-tab-label>Approver Log</ng-template>
          @if (submissionApproval | async; as approval) {
            <div>
              @if (approvalsSelected != 'DEPLOYED' && approvalsSelected != 'APPROVED') {
                <div
                  class="approvers"
                  >
                  <span class="approval-summary-bold">Approvers:</span>
                  <div class="approvers-top">
                    <span class="approval-summary-bold">Waiting for Approval</span>
                    @for (i of requiredApprovers(approval.status.CLIENT); track i) {
                      <div
                        class="waiting-for-approval"
                        >
                        <div class="approved-list">
                          <div class="approved-list-icon yellow"></div>
                          <div class="approved-list-text">
                            <div class="approved-list-text-reviewer">[ Client ]</div>
                          </div>
                        </div>
                      </div>
                    }
                    @for (i of requiredApprovers(approval.status.INTERNAL); track i) {
                      <div
                        class="waiting-for-approval"
                        >
                        <div class="approved-list">
                          <div class="approved-list-icon yellow"></div>
                          <div class="approved-list-text">
                            <div class="approved-list-text-reviewer">[ Clickatell ]</div>
                          </div>
                        </div>
                      </div>
                    }
                    @if (approval.status.TOTAL.required === approval.status.TOTAL.approvedCount) {
                      <div>
                        <div class="approved-list">
                          <div class="approved-list-text">
                            <div class="approved-list-text-reviewer">[ None ]</div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              <div class="approved">
                <span class="approval-summary-bold">Approved</span><br /><br />
                <!-- <div *ngIf="!approval.approvers?.CLIENT && !approval.approvers?.INTERNAL">
                <div class="approved-list-text-reviewer">[ None ]</div>
              </div> -->
              <!-- <div class="approved-list" *ngFor="let internalApprovers of approval.approvers?.INTERNAL">
              <div *ngIf="internalApprovers.action != 'DECLINE'" class="approved-list-icon green"></div>
              <div *ngIf="internalApprovers.action === 'DECLINE'" class="approved-list-icon red"></div>
              <div class="approved-list-text">
                <div class="approved-list-text-reviewer">{{internalApprovers.reviewer}}</div>
                <div class="approved-list-text-date">Date Approved:
                {{internalApprovers.updatedDate | date:"yyyy/MM/dd hh:mm:ss"}}</div>
              </div>
            </div> -->
            <ng-component
              *ngTemplateOutlet="approvers; context: { list: approval.approvers, state: 'APPROVE' }"
              >
            </ng-component>
            <!-- <ng-component *ngTemplateOutlet="approvers; context: {list: approval.approvers?.CLIENT, state: 'APPROVE'}">
          </ng-component> -->
        </div>
        @if (approvalsSelected === 'DECLINED') {
          <div class="declined">
            <span class="approval-summary-bold">Declined</span><br /><br />
            <ng-component
              *ngTemplateOutlet="approvers; context: { list: approval.approvers, state: 'DECLINE' }"
              >
            </ng-component>
            <!-- <ng-component *ngTemplateOutlet="approvers; context: {list: approval.approvers?.CLIENT, state: 'DECLINE'}">
          </ng-component> -->
        </div>
      }
    </div>
  } @else {
    <loading-icon></loading-icon>
  }
</mat-tab>
}
</mat-tab-group>

<ng-template #approvers let-list="list" let-state="state">
  @if (getList(list, state); as submissions) {
    <div>
      @for (internalApprovers of submissions; track internalApprovers) {
        <div>
          <div class="approved-list">
            <div class="approved-list-icon {{ internalApprovers.action }}"></div>
            <div class="approved-list-text">
              <div class="approved-list-text-reviewer">{{ internalApprovers.reviewer }}</div>
              <div class="approved-list-text-date">
                Date {{ state.toLowerCase() }}:
                {{ internalApprovers.updatedDate | date: 'yyyy/MM/dd HH:mm:ss' }}
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="approved-list-text-reviewer">[ None ]</div>
  }
</ng-template>

@if (savingInProgress) {
  <saving-in-progress
    [showSavingInProgress]="savingInProgress"
    [inProgressMessage]="savingInProgressMessage"
    >
  </saving-in-progress>
}



